
import mapboxgl from 'mapbox-gl';

// Function to clean up map layers before re-adding them
export const cleanupLayers = (map: mapboxgl.Map): void => {
  if (!map) return;
  
  // List of layer IDs to clean up
  const layerIds = [
    'region-fills', 
    'region-borders', 
    'region-pledges', 
    'region-selected',
    'chiapas-highlight',
    'hgo-highlight',
    'chis-highlight',
    'hidalgo-fill',
    'chiapas-fill',
    'region-text-labels',
    'region-pledges-labels'
  ];
  
  // Remove each layer if it exists
  layerIds.forEach(layerId => {
    if (map.getLayer(layerId)) {
      console.log(`Removing layer: ${layerId}`);
      map.removeLayer(layerId);
    }
  });
  
  // Cleanup any layers with "fill" in the name
  const allLayers = map.getStyle().layers || [];
  allLayers.forEach(layer => {
    if (
      layer.id.includes('highlight') || 
      layer.id.includes('selected') || 
      layer.id.includes('region-') ||
      layer.id.includes('fill')
    ) {
      if (map.getLayer(layer.id)) {
        console.log(`Removing dynamic layer: ${layer.id}`);
        map.removeLayer(layer.id);
      }
    }
  });
  
  // Try to remove the sources as well
  try {
    if (map.getSource('regions')) {
      map.removeSource('regions');
      console.log('Source "regions" removed');
    }
  } catch (error) {
    console.warn('Could not remove source "regions". It might still be used by other layers.');
  }

  // Also attempt to remove any other sources that might have fills
  ['special-regions', 'selected-region'].forEach(sourceId => {
    try {
      if (map.getSource(sourceId)) {
        map.removeSource(sourceId);
      }
    } catch (error) {
      console.warn(`Could not remove source "${sourceId}".`);
    }
  });
};
